import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { TextBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StreetAddress2Field = () => {
    const value = useBrokerDetailsStore((s) => s.homeAddress.street2);
    const updateHomeAddress = useBrokerDetailsStore((s) => s.updateHomeAddress);
    const changed = useBrokerFieldFieldChanged(FormField.HomeStreet2);

    return (
        <>
            <TextBox
                id='hAddress2'
                value={value}
                onChange={(v) => updateHomeAddress({ street2: v })}
                width={'100%'}
                label='Street Address 2'
                placeholder='Suite or unit number if applicable (e.g. 250 East 55th St., Unit 5B)'
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon icon={'asterisk'} className='required-icon' />
            </ShowIf>
        </>
    );
};
